import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Build marker for verification
const BUILD_TIMESTAMP = "2025-12-30T17:30:00Z";
console.log("BUILD:", BUILD_TIMESTAMP);

// Export for use in components
window.BUILD_TIMESTAMP = BUILD_TIMESTAMP;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
